import * as React from "react";
import TextField from "@mui/material/TextField";
import { useTheme } from "@mui/material/styles";

import {
  StyledAutocomplete,
  StyledBox,
  StyledBoxLabel,
  StyledLabelSpan,
} from "./styled";

const compactHelperSx = {
  minHeight: "20px",
  margin: "3px 0 0",
  lineHeight: "20px",
  display: "block",
};

const tableHelperSx = {
  minHeight: "18px",
  height: "18px",
  maxHeight: "18px",
  margin: "2px 0 0",
  lineHeight: "18px",
  display: "block",
  overflow: "hidden",
  textOverflow: "ellipsis",
  whiteSpace: "nowrap",
  boxSizing: "border-box",
};

export default function CustomDropdown({
  options,
  customLabel,
  required,
  color,
  fontSize,
  error,
  helperText,
  value,
  name,
  placeholder,
  setFieldValue,
  isprofile,
  formGrid,
  tableField,
  matchAddressInput,
  profileForm,
  ...rest
}) {
  const useCompactHelper = formGrid || tableField || profileForm;
  const theme = useTheme();
  return (
    <StyledBox
      isprofile={isprofile}
      formGrid={formGrid}
      tableField={tableField}
      matchAddressInput={matchAddressInput}
      profileForm={profileForm}
      {...(profileForm ? { "data-profile-address-field": "" } : {})}
    >
      {customLabel && (
        <StyledBoxLabel color={color} fontSize={fontSize} formGrid={formGrid}>
          {customLabel}
          <StyledLabelSpan>{required ? "*" : ""}</StyledLabelSpan>
        </StyledBoxLabel>
      )}
      <StyledAutocomplete
        isprofile={isprofile}
        tableField={tableField}
        matchAddressInput={matchAddressInput}
        profileForm={profileForm}
        disablePortal={false}
        disableClearable
        options={options ?? []}
        getOptionLabel={(option) =>
          typeof option === "string" ? option : option?.label ?? ""
        }
        isOptionEqualToValue={(option, selected) =>
          String(option?.value ?? "") === String(selected?.value ?? "")
        }
        value={
          (options ?? []).find(
            (opt) => String(opt?.value ?? "") === String(value ?? "")
          ) || null
        }
        onChange={(e, newValue) => {
          setFieldValue(name, newValue?.value ?? "");
        }}
        slotProps={{
          popper: {
            sx: { zIndex: 1600 },
          },
          paper: {
            sx: {
              mt: 0.5,
              borderRadius: 1,
              boxShadow: theme.shadows[8],
              border: `1px solid ${theme.palette.divider}`,
              overflow: "hidden",
              "& .MuiAutocomplete-listbox": {
                py: 0.5,
                px: 0,
                maxHeight: 280,
              },
              "& .MuiAutocomplete-option": {
                py: 1.25,
                px: 2,
                minHeight: 44,
                mx: 0.5,
                my: 0.25,
                borderRadius: 1,
              },
              "& .MuiAutocomplete-option:hover": {
                backgroundColor: theme.palette.action.hover,
              },
              "& .MuiAutocomplete-option.Mui-focused": {
                backgroundColor: theme.palette.action.hover,
              },
            },
          },
        }}
        renderInput={(params) => (
          <TextField
            {...params}
            name={name}
            placeholder={placeholder}
            error={error}
            helperText={useCompactHelper ? helperText || "\u00a0" : helperText}
            FormHelperTextProps={
              useCompactHelper
                ? {
                    sx: tableField ? tableHelperSx : compactHelperSx,
                    style: !helperText ? { visibility: "hidden" } : undefined,
                  }
                : params.FormHelperTextProps
            }
            {...rest}
          />
        )}
      />
    </StyledBox>
  );
}
